module.exports = __webpack_public_path__ + "c983c12dd43a7647d29a689282167e53.svg";